export default "__VITE_ASSET__BetfkXxO__"